<script lang="ts">
	import { SvelteToast } from '@zerodevx/svelte-toast';
	import Sidebar from './Sidebar.svelte';
	import Tailwindcss from './shared/Tailwindcss.svelte';
	import ChatBot from './shared/components/common/ChatBot.svelte';
	import { setupI18n } from './shared/services/i18n';
	import { isAuthenticated, userSession } from './shared/stores';
	
	setupI18n();

	const toastOptions = {
		classes: ['success', 'warning', 'failure'],
	};

	let isAuth: boolean | null = null;

	async function checkAuth() {
        isAuth = await isAuthenticated();

        if (!isAuth) {
            userSession.update((_) => '');
			window.localStorage.clear();
        }
    };

	let checkAuthPromise = checkAuth();
</script>

<Tailwindcss />

<SvelteToast options="{toastOptions}" />

{#await checkAuthPromise}
	<br />
{:then}
	<Sidebar />
	{#if $userSession}
		<ChatBot />
	{/if}
{/await}
